module.exports = __webpack_public_path__ + "img/ds40.cac78283.jpg";